export const SUPPORT_EMAIL = 'support@pacific-sx.com';
export const LEARN_MORE_URL = 'https://circulartree.com/pacific/';
export const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
export const DSA_EMAIL = 'dsa@pacific-sx.com';
export const DSA_SECURE_ETHICS_ENDPOINT =
  'https://secure.ethicspoint.eu/domain/media/en/gui/49157/phone.html';
